/* Zen Carrosserie : ajout au panier (tiroir Horizon), page produit, livraison estimée. */
(function () {
  'use strict';

  // Ajout au panier comme le formulaire produit de Horizon : /cart/add.js avec le rendu des
  // sections panier, puis l'événement standard qui met à jour le tiroir et le compteur.
  // En cas d'échec du script, le formulaire part en POST classique vers /cart/add.
  async function addToCart(form) {
    const id = form.querySelector('[name="id"]')?.value;
    const qty = Math.max(1, parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10));
    if (!id) return false;

    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-zen-error]');
    if (error) error.hidden = true;
    if (button) button.setAttribute('aria-busy', 'true');

    let CartEvent = null;
    try {
      ({ CartLinesUpdateEvent: CartEvent } = await import('@shopify/events'));
    } catch (e) {
      CartEvent = null;
    }
    const deferred = CartEvent ? CartEvent.createPromise() : null;
    if (CartEvent) {
      form.dispatchEvent(
        new CartEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity: qty }],
          promise: deferred.promise,
        })
      );
    }

    try {
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId))];
      const addUrl = ((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add') + '.js';
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }], sections: sectionIds.join(','), sections_url: window.location.pathname }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || "L'ajout au panier a échoué, réessayez.");

      const cartUrl = ((window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart') + '.js';
      const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (deferred) {
        deferred.resolve({
          cart: CartEvent.createCartFromAjaxResponse(cart),
          detail: { sections: data.sections, items: cart.items, itemCount: cart.item_count, source: 'zen-product', didError: false },
        });
      }

      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
      return true;
    } catch (e) {
      if (deferred) deferred.reject(e);
      if (error) {
        error.textContent = (e && e.message) || "L'ajout au panier a échoué, réessayez.";
        error.hidden = false;
        return true;
      }
      return false;
    } finally {
      if (button) button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-zen-add]')) return;
    event.preventDefault();
    const handled = await addToCart(form);
    if (!handled) form.submit();
  });

  // Page produit : offre (produit seul ou kit), quantité, galerie, bouton collant.
  function initProduct(root) {
    const form = root.querySelector('[data-zen-buy]');
    if (!form) return;
    const idInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const priceEl = root.querySelector('[data-zen-price]');
    const stickyPrice = document.querySelector('[data-zen-sticky-price]');
    const stickyName = document.querySelector('[data-zen-sticky-name]');

    root.querySelectorAll('input[name="zen-offer"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        idInput.value = radio.value;
        if (priceEl) priceEl.textContent = radio.dataset.price;
        root.querySelectorAll('[data-zen-btn-price]').forEach((el) => { el.textContent = radio.dataset.price; });
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        if (stickyName) stickyName.textContent = radio.dataset.name;
      });
    });

    root.querySelectorAll('[data-zen-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const next = Math.min(99, Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.zenStep, 10)));
        qtyInput.value = next;
      });
    });

    initGallery(root);
    initClamp(root);

    const sticky = document.querySelector('[data-zen-sticky]');
    const buyButton = form.querySelector('[type="submit"]');
    if (sticky && buyButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const below = entry.boundingClientRect.top < 0;
        sticky.classList.toggle('z-show', !entry.isIntersecting && below);
      }).observe(buyButton);
      sticky.querySelector('button')?.addEventListener('click', () => {
        if (form.requestSubmit) form.requestSubmit(buyButton);
        else buyButton.click();
      });
    }
  }


  // Galerie : piste à glissement natif (scroll-snap), flèches, compteur, points, miniatures,
  // lecture de la vidéo quand elle est à l'écran, et zoom plein écran au clic sur une photo.
  function initGallery(root) {
    const gal = root.querySelector('[data-zen-gallery]');
    if (!gal || gal.dataset.ready) return;
    gal.dataset.ready = '1';
    const track = gal.querySelector('[data-zen-track]');
    const slides = [...gal.querySelectorAll('[data-zen-slide]')];
    const thumbs = [...gal.querySelectorAll('[data-zen-goto]')];
    const dots = [...gal.querySelectorAll('.z-gal-dots i')];
    const count = gal.querySelector('[data-zen-count]');
    let current = 0;

    const goTo = (i) => {
      const n = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    const setActive = (i) => {
      if (i === current && count && count.textContent === String(i + 1)) return;
      current = i;
      if (count) count.textContent = String(i + 1);
      dots.forEach((d, k) => d.classList.toggle('z-on', k === i));
      thumbs.forEach((t, k) => {
        t.setAttribute('aria-selected', String(k === i));
        if (k === i) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
      slides.forEach((s, k) => {
        const v = s.querySelector('video');
        if (!v) return;
        if (k === i) {
          if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
          v.play().catch(() => {});
        }
        else v.pause();
      });
    };

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > 0.6) setActive(slides.indexOf(e.target)); });
      }, { root: track, threshold: [0.6] });
      slides.forEach((s) => io.observe(s));
    }
    gal.querySelector('[data-zen-prev]')?.addEventListener('click', () => goTo(current - 1));
    gal.querySelector('[data-zen-next]')?.addEventListener('click', () => goTo(current + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(parseInt(t.dataset.zenGoto, 10))));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });

    const lb = root.querySelector('[data-zen-lightbox]');
    if (lb && typeof lb.showModal === 'function') {
      const lbTrack = lb.querySelector('[data-zen-lb-track]');
      gal.querySelectorAll('[data-zen-zoom]').forEach((btn) => btn.addEventListener('click', () => {
        lb.showModal();
        const fig = lbTrack.querySelector(`[data-zen-lb-index="${btn.dataset.zenZoom}"]`);
        if (fig) lbTrack.scrollTo({ left: fig.offsetLeft, behavior: 'instant' });
      }));
      lb.querySelector('[data-zen-lb-close]').addEventListener('click', () => lb.close());
      lb.addEventListener('click', (e) => { if (e.target === lb) lb.close(); });
    }
  }

  // Guide long : replié par défaut (le texte reste dans la page pour le référencement).
  function initClamp(root) {
    const box = root.querySelector('[data-zen-clamp]');
    const btn = root.querySelector('[data-zen-more]');
    if (!box || !btn || btn.dataset.ready) return;
    btn.dataset.ready = '1';
    btn.addEventListener('click', () => {
      const open = box.classList.toggle('z-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Replier le guide' : 'Lire la suite du guide';
      if (!open) box.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  }

  // Vidéos : chargées seulement après le chargement de la page et à l'approche de l'écran,
  // puis lues en boucle sans son (l'image principale reste prioritaire).
  function initAutoplay() {
    const vids = [...document.querySelectorAll('video[data-zen-lazy-video]:not([data-ready])')];
    if (!vids.length) return;
    vids.forEach((v) => { v.dataset.ready = '1'; });
    const play = (v) => {
      if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
      v.play().catch(() => {});
    };
    const start = () => {
      if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) play(e.target); else if (e.target.getAttribute('src')) e.target.pause();
      }), { rootMargin: '200px 0px' });
      vids.forEach((v) => io.observe(v));
    };
    if (document.readyState === 'complete') setTimeout(start, 200);
    else window.addEventListener('load', () => setTimeout(start, 200), { once: true });
  }

  // Livraison estimée : 3 à 7 jours ouvrés à partir d'aujourd'hui (week-ends exclus).
  function addBusinessDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }
  function initDelivery() {
    const fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    document.querySelectorAll('[data-zen-delivery]').forEach((el) => {
      const min = parseInt(el.dataset.min || '3', 10);
      const max = parseInt(el.dataset.max || '7', 10);
      const now = new Date();
      el.textContent = `entre le ${fmt.format(addBusinessDays(now, min))} et le ${fmt.format(addBusinessDays(now, max))}`;
    });
    const short = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
    document.querySelectorAll('[data-zen-eta]').forEach((box) => {
      const min = parseInt(box.dataset.min || '3', 10);
      const max = parseInt(box.dataset.max || '7', 10);
      const now = new Date();
      const ship = box.querySelector('[data-zen-day="1"]');
      const range = box.querySelector('[data-zen-day="range"]');
      if (ship) ship.textContent = short.format(addBusinessDays(now, 1));
      if (range) range.textContent = `${short.format(addBusinessDays(now, min))} – ${short.format(addBusinessDays(now, max))}`;
    });
  }

  // Avis : 6 visibles, le reste au clic.
  function initReviews() {
    document.querySelectorAll('[data-zen-reviews-more]:not([data-ready])').forEach((btn) => {
      btn.dataset.ready = '1';
      const grid = btn.previousElementSibling;
      if (!grid || grid.children.length <= 6) { btn.hidden = true; return; }
      btn.addEventListener('click', () => grid.classList.add('z-open'));
    });
  }

  // Apparition au défilement : titres, cartes, étapes et blocs des sections Zen.
  function initReveal() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('zen-js');
    const sel = '.zen .z-section .z-center, .zen .z-card, .zen .z-kit, .zen .z-steps li, .zen .z-love-card, .zen .z-guarantee-band li, .zen .z-faq details, .zen .z-rv-card, .zen .z-demo > *, .zen .z-kitdeal, .zen .z-compare, .zen .z-problem, .zen-reveal';
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('z-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll(sel).forEach((el) => {
      if (el.dataset.zenReveal !== undefined || el.closest('.zen-hero')) return;
      el.setAttribute('data-zen-reveal', '');
      const siblings = el.parentElement ? [...el.parentElement.children].filter((c) => c.matches(sel)) : [];
      const i = siblings.indexOf(el);
      if (i > 0) el.style.setProperty('--zr-delay', `${Math.min(i, 6) * 0.08}s`);
      io.observe(el);
    });
  }

  // Comparateur avant / après : le curseur déplace la séparation.
  function initBeforeAfter() {
    document.querySelectorAll('[data-zen-ba]:not([data-ready])').forEach((box) => {
      box.dataset.ready = '1';
      const input = box.querySelector('input[type="range"]');
      const set = () => box.style.setProperty('--pos', `${input.value}%`);
      input.addEventListener('input', set);
      set();
    });
  }

  // Photos d'acheteurs : agrandissement au clic, navigation flèches et clavier.
  function initUgc() {
    document.querySelectorAll('[data-zen-ugc]:not([data-ready])').forEach((box) => {
      box.dataset.ready = '1';
      const items = [...box.querySelectorAll('.z-ugc-item')];
      const dlg = box.querySelector('dialog');
      const img = dlg.querySelector('img');
      let cur = 0;
      const show = (i) => { cur = (i + items.length) % items.length; img.src = items[cur].dataset.full; };
      items.forEach((b, i) => b.addEventListener('click', () => { show(i); dlg.showModal(); }));
      dlg.querySelector('.z-ugc-close').addEventListener('click', () => dlg.close());
      dlg.querySelector('.z-ugc-prev').addEventListener('click', () => show(cur - 1));
      dlg.querySelector('.z-ugc-next').addEventListener('click', () => show(cur + 1));
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') show(cur - 1);
        if (e.key === 'ArrowRight') show(cur + 1);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-zen-product]').forEach(initProduct);
    initDelivery();
    initAutoplay();
    initReviews();
    initReveal();
    initBeforeAfter();
    initUgc();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Panier : remplacer les articles par le kit qui les contient */
document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-zen-kit-swap]');
  if (!b) return;
  e.preventDefault();
  b.disabled = true;
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  try {
    const lines = JSON.parse(b.dataset.lines || '[]');
    for (const l of lines) await post('/cart/change.js', { id: l.key, quantity: Math.max(0, l.q - 1) });
    await post('/cart/add.js', { items: [{ id: Number(b.dataset.kit), quantity: 1 }] });
  } catch (err) { /* en cas d'erreur, on recharge quand même le panier */ }
  window.location.href = '/cart';
});
